import { HOMEPAGE_SEARCH_ERRORS } from "@homepage_search/api/constants";
import { type HomepageSearchResponse } from "@homepage_search/api/types";
import useSWR from "swr";
import useSWRMutation from "swr/mutation";

import { HomepageSearchResult } from "@/search/api/types";
import { transformSitewideResults } from "@/search/utils/sitewideResult";
import { MUTATION_OPTIONS, getJSON } from "@/utils/swr";

const API_URL = `${import.meta.env.VITE_API_HOST}/api/homepage_search`;

const searchHomepage = getJSON<HomepageSearchResponse>(
  HOMEPAGE_SEARCH_ERRORS.GENERIC_ERROR,
  {
    transformUrl: (url: string, payload: { arg: string }) =>
      `${url}?prefix=${payload.arg}`,
  },
);

export const useHomepageSearchQuery = (
  onSuccess?: (results: HomepageSearchResponse) => void,
) => {
  const { data } = useSWR(API_URL);

  const { trigger, error, isMutating } = useSWRMutation(
    API_URL,
    searchHomepage,
    {
      ...MUTATION_OPTIONS,
      onSuccess,
    },
  );

  return {
    searchResult: transformSitewideResults(
      data?.data ?? [],
    ) as unknown as HomepageSearchResult[],
    searchHomepage: trigger,
    homepageSearchError: error || !!data?.errors.at(0),
    isSearching: isMutating,
  };
};
